import { Component } from '@angular/core';

@Component({
    selector: 'delete-icon',
    templateUrl: './icon.html',
    styleUrls: ['./icon.scss']
})
export class DeleteIconComponent {}
